module.exports = __webpack_public_path__ + "img/icon_circle.13a442a5.svg";